import React from 'react'
import styled from 'styled-components'
import { flex, typography, utils } from '../styles'
import P from "./P"
import A from "./A"
import avatar from "../assets/me.png"

const Outer = styled.div`
  ${flex.vertical.alignCenter}
  ${typography.lh14.normal}
  ${utils.container}
  > * + * {
    margin-top: 1rem;
  }
  > img {
    height: 6rem;
    width: 6rem;
  }
  > h2 {
    ${typography.h3.normal}
  }
`

export default () => (
  <Outer>
    <img src={avatar} alt="Glen Maddern's avatar"/>
    <h2>Hi, I'm Glen Maddern</h2>
    <P>I'm a freelance front-end web developer & consultant from Melbourne, Australia. I
      have <A href="https://glenmaddern.com/" target="_blank">
        done some stuff on the internet before
      </A>.
    </P>
    <P>
      I want to make videos that <strong>dig deeper into the fundamentals of the
      web platform</strong>. Deeper than we usually get time to in our day jobs. Finding
      the enduring lessons from a constantly-changing landscape.
    </P>
    <P>
      But working on the front end means <strong>understanding many fields at once</strong>,
      too. So, in that spirit, these videos will look closely at a wide range of topics,
      from complex performance problems, deep dives into browser internals, poking through interesting
      CSS + SVG demos & taking a pragmatic approach to new tools and technologies. And that's just
      for starters.
    </P>
    <P>
      Start by watching
      the <A href="https://www.youtube.com/c/FrontEndCenter" target="_blank">
        free episodes on YouTube
      </A>. I hope you learn something useful!
      I'm making <strong>new 12-17 minute episodes for subscribers each month</strong>, so I hope you'll
      consider <A onClick={() => window.ga && window.ga('send', 'event', 'cta', 'click', 'me-inline')}
         href="https://gum.co/frontendcenter" target="_blank">
        subscribing to the paid channel!
      </A> 😍
    </P>
  </Outer>
)



/** WEBPACK FOOTER **
 ** ./src/components/Me.js
 **/